import React from 'react'
import { COLOR } from '@farewill/ui/tokens'
import { base64EncodeSvg } from 'lib/svg/helpers'
import { Crematorium } from 'lib/crematoria/types'
import { PLACE_TYPES } from 'lib/crematoria/constants'
import PinIcon from 'components/icons/PinIcon'

type MarkerIcon = {
  url: string
  scaledSize: google.maps.Size
}

const SELECTED_PIN_COLOR_BY_PLACE_TYPE = {
  [PLACE_TYPES.crematorium]: COLOR.STATE.ACTIVE,
  [PLACE_TYPES.receptionVenue]: '#F7CA54',
}

const getMarkerIcon = (
  crematoriumID?: string,
  selectedCrematorium?: Crematorium,
  hoveredCrematorium?: Crematorium,
  venue?: Crematorium
): MarkerIcon | undefined => {
  if (typeof window === 'undefined') return undefined
  // Active pin
  if (crematoriumID === selectedCrematorium?.externalId) {
    return {
      url: base64EncodeSvg(
        <PinIcon
          color={
            SELECTED_PIN_COLOR_BY_PLACE_TYPE[
              selectedCrematorium?.type || PLACE_TYPES.crematorium
            ]
          }
        />
      ),
      scaledSize: new window.google.maps.Size(40, 54),
    }
  }
  // Dignity crematorium pin colour
  if (venue?.type === 'Dignity Crematorium') {
    return {
      url: base64EncodeSvg(<PinIcon color={COLOR.STATE.SUCCESS_120} />),
      scaledSize: new window.google.maps.Size(25, 34),
    }
  }

  // Hovered pin
  if (crematoriumID === hoveredCrematorium?.externalId) {
    return {
      url: base64EncodeSvg(<PinIcon color={COLOR.STATE.ACTIVE} />),
      scaledSize: new window.google.maps.Size(25, 34),
    }
  }

  // Inactive pin
  return {
    url: base64EncodeSvg(<PinIcon color={COLOR.ACCENT.SECONDARY} />),
    scaledSize: new window.google.maps.Size(25, 34),
  }
}

export default getMarkerIcon
